import React, { FC } from "react";
import { Button } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import ErrorBoundaryIllustration from "./ErrorBoundaryIllustration";
import "./ErrorBoundary.css";

type ErrorFallbackViewProps = {
  embedded?: boolean;
  loading?: boolean;
  onRetry?: () => void;
  title?: string;
  message?: string;
};

const ErrorFallbackView: FC<ErrorFallbackViewProps> = ({
  embedded = false,
  loading = false,
  onRetry,
  title = "WE COULDN'T LOAD THIS PAGE",
  message = "DON'T WORRY — THIS HAPPENS SOMETIMES. PLEASE REFRESH THE PAGE AND TRY AGAIN.",
}) => (
  <div
    className={`app-error-boundary${embedded ? " app-error-boundary--embedded" : ""}`}
  >
    <div className="app-error-boundary__content">
      <div className="app-error-boundary__illustration-ring">
        <ErrorBoundaryIllustration />
      </div>
      <h1 className="app-error-boundary__title">{title}</h1>
      <p className="app-error-boundary__message">{message}</p>
      <Button
        type="primary"
        className="app-error-boundary__retry-btn"
        icon={<ReloadOutlined />}
        loading={loading}
        onClick={onRetry ?? (() => window.location.reload())}
      >
        TRY AGAIN
      </Button>
    </div>
  </div>
);

export default ErrorFallbackView;
